import * as React from "react"
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg"

const GooglePlayIcon = () => {
    return (
        <Svg
            width={145}
            height={45}
            viewBox="0 0 145 45"
            fill="none"
        >
            <Path
                d="M140.005 44.695H5.171A4.258 4.258 0 01.927 40.45V4.494A4.258 4.258 0 015.17.25h134.834a4.258 4.258 0 014.245 4.244V40.45a4.258 4.258 0 01-4.245 4.245z"
                fill="#000"
                stroke="#F3F3F3"
                strokeWidth={0.5}
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.688 22.023V10.225c0-.674.561-1.236 1.123-1.236.562 0 .787.112 1.124.337l21.686 11.91c.449.225.674.562.674.9 0 .336-.225.673-.674.898l-21.686 11.91c-.225.113-.562.337-1.124.337s-1.123-.561-1.123-1.236V22.023z"
                fill="url(#paint0_linear_1164_12115)"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.732 22.135L12.586 8.99h.225c.562 0 .786.112 1.123.337L29.89 18.09l-4.158 4.045z"
                fill="url(#paint1_linear_1164_12115)"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.78 26.068l-4.046-4.045 4.158-4.157 5.73 3.146c.45.225.674.562.674.899 0 .337-.224.674-.674.899l-5.843 3.258z"
                fill="url(#paint2_linear_1164_12115)"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.7 35.057l13.034-13.034 4.045 4.045-15.843 8.652c-.337.225-.562.337-1.236.337.113 0 .113 0 0 0z"
                fill="url(#paint3_linear_1164_12115)"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.566 38.09c-.562-.449-1.011-1.235-1.236-1.685l1.798-.786c.112.224.337.562.562.899.45.449 1.123.898 1.797.898.675 0 1.461-.337 1.91-.898.338-.562.563-1.124.563-1.91v-.675c-1.349 1.686-4.158 1.46-5.731-.337-1.685-1.798-1.685-4.831 0-6.63 1.686-1.685 4.157-1.91 5.618-.336v-.787h1.91v8.427c0 2.135-.786 3.371-1.797 4.158-.675.562-1.686.786-2.585.786-1.011-.112-2.022-.45-2.809-1.123zm47.08.45l1.91-4.494-3.371-7.753h1.91l2.36 5.505 2.359-5.505h1.911l-5.169 12.247h-1.91zm-9.102-4.27c-.561-.562-.786-1.348-.786-2.135 0-.674.225-1.348.674-1.797.787-.787 1.91-1.124 3.146-1.124.787 0 1.461.112 2.023.45 0-1.349-1.124-1.91-2.023-1.91-.786 0-1.573.449-1.91 1.235l-1.685-.674c.337-.786 1.236-2.247 3.483-2.247 1.123 0 2.247.337 2.921 1.123.674.787.899 1.686.899 2.922v4.72h-1.91v-.787c-.225.337-.674.561-1.011.786-.45.225-1.012.337-1.573.337-.675-.112-1.686-.337-2.248-.899zm-59.888-4.045c0-2.247 1.685-4.719 4.719-4.719 2.921 0 4.719 2.472 4.719 4.72 0 2.246-1.685 4.718-4.72 4.718-3.033 0-4.718-2.472-4.718-4.719zm10.112 0c0-2.247 1.686-4.719 4.72-4.719 2.92 0 4.719 2.472 4.719 4.72 0 2.246-1.686 4.718-4.72 4.718-2.921 0-4.719-2.472-4.719-4.719zm-22.81 2.472c-2.808-2.809-2.696-7.416.113-10.337 1.46-1.46 3.259-2.135 5.169-2.135 1.797 0 3.595.674 4.944 2.023l-1.349 1.46c-2.022-2.022-5.28-1.91-7.19.113a5.429 5.429 0 000 7.528c2.022 2.135 5.392 2.247 7.415.112.674-.674.899-1.573 1.011-2.472h-4.719v-2.022h6.63c.112.45.112 1.011.112 1.573 0 1.685-.674 3.37-1.798 4.494-1.236 1.236-3.034 1.91-4.832 1.91-2.022-.112-4.045-.786-5.505-2.247zm47.53.787c-1.686-1.798-1.686-4.832 0-6.742 1.685-1.798 4.494-1.798 6.067 0 .562.562.899 1.348 1.236 2.135l-6.18 2.584a2.397 2.397 0 002.248 1.461c1.01 0 1.685-.337 2.36-1.348l1.685 1.123c-.225.225-.45.45-.562.674-1.91 1.91-5.169 1.91-6.854.113zm11.685 1.348V22.36h4.045c2.36 0 4.27 1.685 4.27 3.708 0 2.022-1.685 3.708-3.82 3.708h-2.472v4.944h-2.023v.112zm9.439 0V22.36h1.91v12.472h-1.91zm-25.394-.225V20.674h2.022v13.933h-2.022zm34.27-3.483c-.449-.337-1.123-.45-1.797-.45-1.349 0-2.135.675-2.135 1.462 0 .786.786 1.235 1.573 1.235 1.123 0 2.359-.899 2.359-2.247zm-57.529-.899c0-1.348-.899-2.809-2.584-2.809-1.686 0-2.585 1.461-2.585 2.81 0 1.348.9 2.808 2.585 2.808 1.573 0 2.584-1.46 2.584-2.809zm10.113 0c0-1.348-.9-2.809-2.585-2.809s-2.584 1.461-2.584 2.81c0 1.348.899 2.808 2.584 2.808 1.686 0 2.585-1.46 2.585-2.809zm10 .787c0-.113 0-.225.112-.337v-.45-.561c0-.113-.112-.338-.112-.45-.337-1.124-1.349-1.91-2.36-1.91-1.348 0-2.472 1.348-2.472 2.809 0 1.573 1.124 2.809 2.585 2.809.898.112 1.797-.674 2.247-1.91zM94.274 30l4.158-1.798c-.45-.787-1.124-1.011-1.686-1.011-1.685.112-2.697 1.91-2.472 2.809zm17.192-3.82c0-1.124-.899-1.91-2.135-1.91h-2.247v3.932h2.359a2.014 2.014 0 002.023-2.023z"
                fill="#fff"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M129.107 36.294h-.114v-.114h.114-.114v.114h.114zM129.332 36.294c0-.114 0-.114 0 0-.113-.114-.113-.114 0 0-.113 0-.113 0 0 0zm0-.114c0 .114 0 .114 0 0-.113.114 0 .114 0 0z"
                fill="#fff"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M129.444 36.18h-.113.113v.114-.114z"
                fill="#fff"
            />
            <Path
                d="M44.386 11.349c0-2.023 1.46-3.259 3.258-3.259 1.236 0 2.023.562 2.585 1.348l-.9.562c-.336-.45-.898-.786-1.685-.786-1.236 0-2.135.899-2.135 2.247 0 1.348.9 2.247 2.135 2.247.674 0 1.236-.337 1.461-.562v-1.01h-1.798v-1.012h3.034v2.36c-.562.674-1.46 1.123-2.584 1.123-1.91 0-3.371-1.348-3.371-3.258zM51.688 14.495V8.202h4.27v1.012H52.7v1.573h3.146v1.011H52.7v1.798h3.258v1.011l-4.27-.112zM59.103 14.495V9.214h-1.91V8.202h4.944v1.012h-1.91v5.28h-1.123zM65.96 14.495V8.202h1.124v6.293H65.96zM70.117 14.495V9.214h-1.91V8.202h4.944v1.012h-1.91v5.28h-1.124zM76.746 11.349c0-1.91 1.348-3.259 3.259-3.259 1.91 0 3.258 1.348 3.258 3.259 0 1.91-1.348 3.258-3.258 3.258s-3.259-1.46-3.259-3.258zm5.281 0c0-1.349-.786-2.248-2.135-2.248-1.236 0-2.135 1.012-2.135 2.248 0 1.348.787 2.247 2.135 2.247 1.349 0 2.135-1.011 2.135-2.247zM88.881 14.495L85.623 10v4.495h-1.124V8.202h1.124l3.258 4.383V8.201h1.124v6.293H88.88z"
                fill="#fff"
            />
            <Defs>
                <LinearGradient
                    id="paint0_linear_1164_12115"
                    x1={18.9544}
                    y1={7.38604}
                    x2={25.2446}
                    y2={33.219}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#006884" />
                    <Stop offset={1} stopColor="#8AD1D0" />
                </LinearGradient>
                <LinearGradient
                    id="paint1_linear_1164_12115"
                    x1={11.2833}
                    y1={11.0605}
                    x2={28.4252}
                    y2={20.3275}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#24BBB6" />
                    <Stop offset={1} stopColor="#DBE692" />
                </LinearGradient>
                <LinearGradient
                    id="paint2_linear_1164_12115"
                    x1={31.0091}
                    y1={26.5402}
                    x2={31.0091}
                    y2={17.6092}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#FCC072" />
                    <Stop offset={1} stopColor="#F58A5B" />
                </LinearGradient>
                <LinearGradient
                    id="paint3_linear_1164_12115"
                    x1={14.6044}
                    y1={37.3818}
                    x2={28.1459}
                    y2={23.6004}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#712B8F" />
                    <Stop offset={1} stopColor="#EA1D27" />
                </LinearGradient>
            </Defs>
        </Svg>
    )
}

export { GooglePlayIcon };
